document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Product gallery — switch between images/videos/3D models via thumbnails
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mediaItems = document.querySelectorAll('[data-main-media] .product__media-item');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var targetId = thumb.getAttribute('data-media-id');

      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');

      mediaItems.forEach(function (item) {
        var isTarget = item.getAttribute('data-media-id') === targetId;
        item.classList.toggle('is-active', isTarget);
        if (!isTarget) {
          var video = item.querySelector('video');
          if (video) { video.pause(); }
        }
      });
    });
  });

  // Variant select -> update displayed price
  var variantSelect = document.getElementById('ProductVariantSelect');
  var priceEl = document.getElementById('ProductPrice');
  var stickyPriceEl = document.querySelector('.sticky-cta__price');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var price = selected.getAttribute('data-price');
      if (price) {
        priceEl.textContent = price;
        if (stickyPriceEl) { stickyPriceEl.textContent = price; }
      }
    });
  }

  // Sticky mobile add-to-cart bar
  var addToCartButton = document.getElementById('AddToCartButton');
  var stickyCta = document.querySelector('[data-sticky-cta]');
  if (addToCartButton && stickyCta && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyCta.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });
    observer.observe(addToCartButton);

    var stickyButton = document.querySelector('[data-sticky-cta-button]');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var form = document.getElementById('ProductForm');
        if (form && form.requestSubmit) {
          form.requestSubmit();
        } else if (form) {
          form.submit();
        }
      });
    }
  }

  // Header language switcher dropdown
  var langSwitcher = document.querySelector('[data-language-switcher]');
  if (langSwitcher) {
    var langToggle = langSwitcher.querySelector('[data-language-switcher-toggle]');
    var langDropdown = langSwitcher.querySelector('[data-language-switcher-dropdown]');

    langToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = !langDropdown.hidden;
      langDropdown.hidden = isOpen;
      langToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    document.addEventListener('click', function (e) {
      if (!langSwitcher.contains(e.target)) {
        langDropdown.hidden = true;
        langToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Language popup — show once on first visit
  var languagePopup = document.querySelector('[data-language-popup]');
  if (languagePopup) {
    var STORAGE_KEY = 'language_popup_dismissed';
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        languagePopup.hidden = false;
      }
    } catch (e) {
      // localStorage unavailable (e.g. private browsing) — skip popup
    }

    var dismissPopup = function () {
      languagePopup.hidden = true;
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    };

    document.querySelectorAll('[data-language-popup-close]').forEach(function (el) {
      el.addEventListener('click', dismissPopup);
    });

    // If the customer actively picks a language, remember that too
    var languageForm = document.getElementById('LanguagePopupForm');
    if (languageForm) {
      languageForm.addEventListener('submit', function () {
        try {
          localStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {}
      });
    }
  }

  // Print service request form — bundle extra fields into contact[body]
  var printServiceForm = document.getElementById('PrintServiceForm');
  if (printServiceForm) {
    printServiceForm.addEventListener('submit', function () {
      var get = function (name) {
        var el = printServiceForm.querySelector('[data-field="' + name + '"]');
        return el ? el.value : '';
      };
      var body = [
        'Typ av tjänst: ' + get('service_type'),
        'Beskrivning: ' + get('description'),
        'Fillänk: ' + get('file_link'),
        'Mått: ' + get('dimensions'),
        'Material: ' + get('material'),
        'Antal: ' + get('quantity'),
        'Budget: ' + get('budget')
      ].join('\n');
      var bodyField = printServiceForm.querySelector('[data-body-field]');
      if (bodyField) { bodyField.value = body; }
    });
  }

  // Cart consent checkbox — required before checkout, records timestamp
  function initCartConsent() {
    var cartConsent = document.getElementById('CartConsentCheckbox');
    var cartCheckoutButton = document.getElementById('CartCheckoutButton');
    var cartConsentAttribute = document.getElementById('CartConsentAttribute');
    if (cartConsent && cartCheckoutButton) {
      cartConsent.addEventListener('change', function () {
        cartCheckoutButton.disabled = !cartConsent.checked;
        if (cartConsentAttribute) {
          cartConsentAttribute.value = cartConsent.checked
            ? 'Bekräftat ' + new Date().toISOString()
            : 'Ej bekräftat';
        }
      });
    }
  }
  initCartConsent();

  // Product series quick-add — adds to cart without leaving the page
  var quickAddButtons = document.querySelectorAll('[data-quick-add]');
  quickAddButtons.forEach(function (button) {
    var form = button.closest('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (button.disabled) return;
      var originalText = button.textContent;
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          button.classList.add('is-added');
          button.textContent = '✓';
          setTimeout(function () {
            button.classList.remove('is-added');
            button.textContent = originalText;
          }, 1800);
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('.site-header__cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
          } else if (cart.item_count > 0) {
            var cartLink = document.querySelector('.site-header__cart');
            if (cartLink) {
              var span = document.createElement('span');
              span.className = 'site-header__cart-count';
              span.textContent = cart.item_count;
              cartLink.appendChild(span);
            }
          }
        })
        .catch(function () {
          button.textContent = originalText;
        });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Main product "Add to cart" — AJAX add, then open the "Complete your set" modal
  var mainForm = document.getElementById('ProductForm');
  var mainButton = document.getElementById('MainAddToCart');
  var seriesModal = document.getElementById('SeriesModal');

  function updateHeaderCartCount(cart) {
    var countEl = document.querySelector('.site-header__cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
    } else if (cart.item_count > 0) {
      var cartLink = document.querySelector('.site-header__cart');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'site-header__cart-count';
        span.textContent = cart.item_count;
        cartLink.appendChild(span);
      }
    }
  }

  function openSeriesModal() {
    if (!seriesModal) return;
    seriesModal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeSeriesModal() {
    if (!seriesModal) return;
    seriesModal.hidden = true;
    document.body.style.overflow = '';
  }

  if (seriesModal) {
    seriesModal.querySelectorAll('[data-series-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeSeriesModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSeriesModal();
    });
  }

  if (mainForm && mainButton) {
    mainForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var originalText = mainButton.textContent;
      mainButton.disabled = true;
      var formData = new FormData(mainForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          mainButton.disabled = false;
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateHeaderCartCount(cart);
          if (seriesModal) {
            openSeriesModal();
          }
        })
        .catch(function () {
          mainButton.disabled = false;
          mainButton.textContent = originalText;
        });
    });
  }

  // Cart quantity steppers — auto-update the cart via AJAX, no page reload
  var cartUpdateTimers = {};

  function updateHeaderCartCountValue(count) {
    var countEl = document.querySelector('.site-header__cart-count');
    if (countEl) {
      countEl.textContent = count;
    } else if (count > 0) {
      var cartLink = document.querySelector('.site-header__cart');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'site-header__cart-count';
        span.textContent = count;
        cartLink.appendChild(span);
      }
    }
  }

  function refreshCartSection() {
    fetch('/cart?section_id=main&_=' + Date.now(), { cache: 'no-store' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newCart = doc.querySelector('.cart');
        var oldCart = document.querySelector('.cart');
        if (newCart && oldCart) {
          oldCart.replaceWith(newCart);
          initQuantitySteppers();
          initCartConsent();
        }
        return fetch('/cart.js', { cache: 'no-store' });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateHeaderCartCountValue(cart.item_count);
      })
      .catch(function () {});
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(function () {
      refreshCartSection();
    });
  }

  function scheduleCartLineUpdate(line, quantity) {
    if (cartUpdateTimers[line]) {
      clearTimeout(cartUpdateTimers[line]);
    }
    cartUpdateTimers[line] = setTimeout(function () {
      changeCartLine(line, quantity);
    }, 500);
  }

  function initQuantitySteppers() {
    document.querySelectorAll('[data-quantity-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-quantity-input]');
      var decreaseBtn = stepper.querySelector('[data-quantity-decrease]');
      var increaseBtn = stepper.querySelector('[data-quantity-increase]');
      var line = stepper.getAttribute('data-line');
      if (!input) return;

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var value = parseInt(input.value, 10) || 0;
          value = Math.max(0, value - 1);
          input.value = value;
          if (line) scheduleCartLineUpdate(line, value);
        });
      }
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          var value = parseInt(input.value, 10) || 0;
          value = value + 1;
          input.value = value;
          if (line) scheduleCartLineUpdate(line, value);
        });
      }
    });

    document.querySelectorAll('[data-cart-remove]').forEach(function (removeLink) {
      removeLink.addEventListener('click', function (e) {
        e.preventDefault();
        var line = removeLink.getAttribute('data-line');
        if (line) changeCartLine(line, 0);
      });
    });
  }
  initQuantitySteppers();
});

document.addEventListener('DOMContentLoaded', function () {
  // Collection type tabs (Products / Digital files)
  var typeTabs = document.querySelector('[data-type-tabs]');
  if (typeTabs) {
    var tabs = typeTabs.querySelectorAll('[data-type-tab]');
    var panels = document.querySelectorAll('[data-type-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-type-tab');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-type-panel') !== target;
        });
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Print service form — material options depend on chosen service type
  var serviceTypeSelect = document.getElementById('ps_service_type');
  var materialSelect = document.getElementById('ps_material');

  var materialOptions = {
    '3D-print': [
      { value: 'PLA', label: 'PLA' },
      { value: 'PETG', label: 'PETG' },
      { value: 'Annat', label: 'Annat' }
    ],
    'CNC': [
      { value: 'Trä', label: 'Trä' },
      { value: 'Akryl', label: 'Akryl' },
      { value: 'Annat', label: 'Annat' }
    ],
    'Vet ej / önskar förslag': [
      { value: 'Vet ej / önskar förslag', label: 'Vet ej / önskar förslag' }
    ]
  };

  function updateMaterialOptions() {
    if (!serviceTypeSelect || !materialSelect) return;
    var selected = serviceTypeSelect.value;
    var options = materialOptions[selected] || materialOptions['Vet ej / önskar förslag'];
    materialSelect.innerHTML = '';
    options.forEach(function (opt) {
      var el = document.createElement('option');
      el.value = opt.value;
      el.textContent = opt.label;
      materialSelect.appendChild(el);
    });
  }

  if (serviceTypeSelect && materialSelect) {
    serviceTypeSelect.addEventListener('change', updateMaterialOptions);
    updateMaterialOptions();
  }
});
